const NAME_INPUT_SELECTOR = '.registration-form-field-name input';
const ASCII_REGEX = /^[\x20-\x7E]*$/;
const NON_ASCII_REGEX = /[^\x20-\x7E]/g;
const RULE_NAME = 'singleByteOnly';

function toAscii(value) {
  return (value || '').replace(NON_ASCII_REGEX, '');
}

/**
 * Translated in PHP by SingleByteNameValidator::errorMessage() and emitted into wp_head,
 * so the server-side rejection and this message always read the same in every language.
 */
function errorMessage() {
  return window.singleByteNameError;
}

function getValidator(input) {
  return input.form && window.jQuery
    ? window.jQuery(input.form).data('validator') || null
    : null;
}

function revalidate(input) {
  getValidator(input)?.element(input);
}

/**
 * Rejected keystrokes and stripped pastes never reach the field's value, so the rule below
 * would see a valid (often empty) input and stay silent. Surface the message explicitly,
 * otherwise the user just sees their typing vanish — or a bare "field is required".
 */
function showSingleByteError(input) {
  getValidator(input)?.showErrors({ [input.name]: errorMessage() });
}

/**
 * Registers the rule on WPForms' jQuery Validate instance, so the error renders as the
 * standard `em.wpforms-error` element and submit blocking is handled by WPForms itself.
 */
function applyRule(input) {
  if (!getValidator(input)) {
    return;
  }

  const $ = window.jQuery;

  if (!$.validator.methods[RULE_NAME]) {
    $.validator.addMethod(RULE_NAME, function (value, element) {
      return this.optional(element) || ASCII_REGEX.test(value);
    });
  }

  $(input).rules('add', {
    [RULE_NAME]: true,
    messages: { [RULE_NAME]: errorMessage() },
  });
}

function bindInputValidation(input) {
  if (input.dataset.singleByteBound) {
    return;
  }
  // eslint-disable-next-line no-param-reassign
  input.dataset.singleByteBound = '1';

  input.addEventListener('beforeinput', (event) => {
    if (typeof event.data !== 'string' || event.data.length === 0) {
      return;
    }

    if (!ASCII_REGEX.test(event.data)) {
      event.preventDefault();
      showSingleByteError(input);
    }
  });

  input.addEventListener('paste', (event) => {
    const clipboard = event.clipboardData?.getData('text') || '';
    const sanitized = toAscii(clipboard);

    if (clipboard === sanitized) {
      return;
    }

    event.preventDefault();
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    // eslint-disable-next-line no-param-reassign
    input.value = `${input.value.slice(0, start)}${sanitized}${input.value.slice(end)}`;
    const nextCaret = start + sanitized.length;
    input.setSelectionRange(nextCaret, nextCaret);
    showSingleByteError(input);
  });

  // `beforeinput` does not fire for IME commits, so CJK typed via a Japanese or Chinese
  // IME is only caught here. Blur and keyup are already covered by jQuery Validate.
  input.addEventListener('compositionend', () => revalidate(input));
  input.addEventListener('input', (event) => {
    if (!event.isComposing) {
      revalidate(input);
    }
  });
}

function bindAll() {
  document.querySelectorAll(NAME_INPUT_SELECTOR).forEach((input) => {
    bindInputValidation(input);
    applyRule(input);
  });
}

export default function formValidation() {
  bindAll();

  // WPForms initialises its validator after DOM ready and re-renders fields on
  // conditional-logic and multi-page changes, so rebind on its own lifecycle events.
  window.jQuery?.(document).on('wpformsReady wpformsPageChange', bindAll);
}
